import React from 'react';
import CollectionQueryForm from 'Components/ComponentLibrary/Molecules/CollectionQueryForm';
import PropTypes from 'prop-types';
import HouseholdSelectLayout from 'Components/ComponentLibrary/Components/Uncategorized/HouseholdSelect/Layout';
import { noop } from 'Helpers/PropTypes';
import { HouseholdSelectMetaOverrideSet } from './MetaOverrideSet';

const HouseholdSelect = ({
  collection, beforeSubmit, onSubmit, disabled,
}) => {
  return (
    <CollectionQueryForm
      metaOverrideSet={HouseholdSelectMetaOverrideSet}
      layout={HouseholdSelectLayout}
      collection={collection}
      formPadding={'none'}
      LayoutProps={{
        disabled,
      }}
      beforeSubmit={(householdId) => beforeSubmit(householdId)}
      onSubmit={(filterResultCollection, value) => {
        onSubmit(filterResultCollection, value);
      }}
    />
  );
};

HouseholdSelect.defaultProps = {
  beforeSubmit: noop,
  onSubmit: noop,
  disabled: false,
};

HouseholdSelect.propTypes = {
  collection: PropTypes.object.isRequired,
  beforeSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  disabled: PropTypes.bool,
};
export default HouseholdSelect;
